import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DocumentService from '@/shared/services/DocumentService';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import classNames from 'classnames';
import YesNoModal from '@/shared/components/YesNoModal';

import FileIcon from './FileIcon';
import { DeleteIcon } from './Icons';
import { CanDelete } from './security';
import AuthService from '../services/AuthService';

const messages = defineMessages({
  DeleteAttachment: 'Delete attachment',
  Delete: 'Delete',
  DeleteAttachmentConfirmationMsg: 'Are you sure you want to delete this attachment?',
});

class InlineAttachment extends Component {
  state = { showDeleteModal: false };
  constructor(props) {
    super(props);
    this.canDownload = AuthService.hasPermission({ functionality: 'Documents', privilege: 'Read' });
  }

  render() {
    const {
      attachment,
      onDelete,
      noDownload,
      intl,
      className,
      showDeleteConfirmation,
    } = this.props;
    const { showDeleteModal } = this.state;

    if (attachment) {
      return (
        <React.Fragment>
          {showDeleteModal && (
            <YesNoModal
              intl={intl}
              show
              title={intl.formatMessage(messages.Delete)}
              message={intl.formatMessage(messages.DeleteAttachmentConfirmationMsg)}
              onNo={() =>
                this.setState(state => ({
                  ...state,
                  showDeleteModal: false,
                }))
              }
              onSave={() => onDelete(attachment)}
            />
          )}
          <span className={classNames(className, 'inline-email-attachment')}>
            <span>
              {!noDownload && this.canDownload && attachment.id ? (
                // eslint-disable-next-line no-script-url
                <a onClick={() => DocumentService.download(attachment.id)}>
                  <span>
                    <FileIcon document={attachment} /> {attachment.name}
                  </span>
                </a>
              ) : (
                <span>
                  <FileIcon document={attachment} /> {attachment.name}
                </span>
              )}
            </span>
            {onDelete && (
              <DeleteIcon
                className="delete-icon"
                onClick={() =>
                  showDeleteConfirmation
                    ? this.setState({ showDeleteModal: true })
                    : onDelete(attachment)
                }
                tooltip={intl.formatMessage(messages.DeleteAttachment)}
              />
            )}
          </span>
        </React.Fragment>
      );
    }
  }
}

InlineAttachment.propTypes = {
  attachment: PropTypes.shape({
    id: PropTypes.string,
    scanStatus: PropTypes.number,
    name: PropTypes.string,
    documentType: PropTypes.number,
  }).isRequired,
  onDelete: PropTypes.func,
  noDownload: PropTypes.bool,
  intl: intlShape.isRequired,
  showDeleteConfirmation: PropTypes.bool,
};

InlineAttachment.defaultProps = {
  onDelete: null,
  noDownload: false,
  showDeleteConfirmation: true,
};

export default injectIntl(InlineAttachment);
